import ProductCategoryListingContainer from "./ProductCategoryListingContainer";

export default ProductCategoryListingContainer;
